import { typeof as _typeof } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { THEME_UI_DEFAULT_KEY } from '../../theme-provider/types.esm.js';

function safeColor(color) {
  if (typeof color === 'string') return color;
  if (_typeof(color) === 'object' && THEME_UI_DEFAULT_KEY in color) return color[THEME_UI_DEFAULT_KEY];
  return '#fff';
}

export { safeColor };
//# sourceMappingURL=utils.esm.js.map
